import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";

import MenuItem from "@mui/material/MenuItem";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import equipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useItemSelectedFilterContext } from "../../../Context/GridEquipListContext";
import { useAMGSelectedContext } from "../../../Context/GlobalContext";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../../Constants/EquipmentGroupConstants";
import { attachingDropDown } from "./HelperDashboard";
const initialMsg = {
  messageBoxText: {},
  msgButtons: [],
  messageBoxOpen: false,
};
export default function ExportButton({ handleExport, reportCode, state }) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const selectedAnlageG = useAMGSelectedContext();

  let handleDownload = (bildOption) => {
    setGlobalSpinner(true);
    const _tempFilter = attachingDropDown(
      [...itemSelectedFilter],
      state,
      reportCode
    );
    equipmentGroupActions.getExportDaten(
      selectedAnlageG,
      bildOption,
      _tempFilter,
      reportCode,
      null
    );
    handleExport(initialMsg);
  };
  const downloadMitBilderEvent = () => {
    handleDownload("with");
  };

  const downloadOhneBilderEvent = () => {
    handleDownload("none");
  };

  const downloadEvent = (event) => {
    handleExport({
      messageBoxText: {
        title: "Export-Export",
        msg: localization.downloadMsg,
        anlageID: 0,
      },
      msgButtons: [
        {
          title: localization.cancelbutton,
          func: () => handleExport(initialMsg),
        },
        {
          title: localization.exportWithimg,
          func: downloadMitBilderEvent,
        },
        {
          title: localization.exportWithoutImg,
          func: downloadOhneBilderEvent,
        },
      ],
      messageBoxOpen: true,
    });
    //   event.preventDefault();
    // hideMenu();handleExport
    //   setMessageBoxOpen(
    //       {
    //   messageBoxText: {
    //     title: "Export-Export",
    //     msg: localization.downloadMsg,
    //     anlageID: 0,
    //   },
    //   msgButtons: [
    //     {
    //       title: localization.cancelbutton,
    //       func: () => setMessageBoxOpen(initialMsg),
    //     },
    //     {
    //       title: localization.exportWithimg,
    //       func: downloadMitBilderEvent,
    //     },
    //     {
    //       title: localization.exportWithoutImg,
    //       func: downloadOhneBilderEvent,
    //     },
    //   ],
    //   messageBoxOpen: true,
    // });
  };

  return (
    <>
      <MenuItem
        onClick={(e) => {
          downloadEvent(e);
        }}
      >
        {localization.downloadExcel}
      </MenuItem>
    </>
  );
}
